"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalSizes = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var prop_types_1 = require("prop-types");

var Modal_1 = __importDefault(require("react-bootstrap/Modal"));

var Button_1 = __importDefault(require("../Button"));

require("./index.css");

exports.modalSizes = {
  SMALL: 'sm',
  LARGE: 'lg',
  XLARGE: 'xlg'
};

var ModalConfirmation = function (_a) {
  var show = _a.show,
      size = _a.size,
      title = _a.title,
      body = _a.body,
      closeConfig = _a.closeConfig,
      submitConfig = _a.submitConfig,
      props = __rest(_a, ["show", "size", "title", "body", "closeConfig", "submitConfig"]);

  return (0, jsx_runtime_1.jsxs)(Modal_1.default, __assign({
    centered: true,
    show: show,
    size: size,
    bsPrefix: "modal-confirmation",
    onHide: closeConfig.onClick
  }, props, {
    children: [(0, jsx_runtime_1.jsx)(Modal_1.default.Header, __assign({
      closeButton: true
    }, {
      children: title && (0, jsx_runtime_1.jsx)(Modal_1.default.Title, {
        children: title
      }, void 0)
    }), void 0), (0, jsx_runtime_1.jsx)(Modal_1.default.Body, {
      children: body
    }, void 0), (0, jsx_runtime_1.jsxs)(Modal_1.default.Footer, {
      children: [(0, jsx_runtime_1.jsx)(Button_1.default, __assign({
        "data-testid": "cancelButton",
        className: "button-link",
        onClick: closeConfig.onClick
      }, {
        children: closeConfig.text
      }), void 0), (0, jsx_runtime_1.jsx)(Button_1.default, __assign({
        "data-testid": "submitButton",
        onClick: submitConfig.onClick
      }, {
        children: submitConfig.text
      }), void 0)]
    }, void 0)]
  }), void 0);
};

var buttonConfigShape = {
  text: prop_types_1.string.isRequired,
  onClick: prop_types_1.func.isRequired
};
ModalConfirmation.propTypes = {
  show: prop_types_1.bool,
  size: (0, prop_types_1.oneOf)(Object.values(exports.modalSizes)),
  title: prop_types_1.string,
  body: (0, prop_types_1.oneOfType)([prop_types_1.element.isRequired, prop_types_1.string.isRequired]),
  closeConfig: (0, prop_types_1.shape)(buttonConfigShape),
  submitConfig: (0, prop_types_1.shape)(buttonConfigShape)
};
ModalConfirmation.defaultProps = {
  show: false,
  size: exports.modalSizes.SMALL,
  title: null,
  body: '',
  closeConfig: {
    text: 'Cancel',
    onClick: function () {}
  },
  submitConfig: {
    text: 'Submit',
    onClick: function () {}
  }
};
exports.default = ModalConfirmation;